"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepCodeResponseMapper = void 0;
var RepCodeResponseMapper = /** @class */ (function () {
    function RepCodeResponseMapper(data) {
        this.localData = data;
    }
    RepCodeResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return RepCodeResponseMapper;
}());
exports.RepCodeResponseMapper = RepCodeResponseMapper;
//# sourceMappingURL=RepCodeResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/RepCodeResponseMapper.js
// module id = 1971
// module chunks = 8